import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimChapterEnum, BimWorkOrderPriceStatesData } from 'gql/graphql';

import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { bimWorkOrderPriceStatesGql } from '../bimWorkOrderQueries';

const requestId = 'bimWorkOrderPriceStates';

export const useBimWorkOrderPriceStates = (chapter?: BimChapterEnum, workOrderObjectId?: number) => {
    const dispatch = useDispatch();
    const [bimWorkOrderPriceStatesReset] = useResetStoreData({ requestId });

    const variables = useMemo(
        () => (chapter && workOrderObjectId ? { chapter, workOrderObjectId } : undefined),
        [chapter, workOrderObjectId],
    );

    const [bimWorkOrderPriceStatesData, , , bimWorkOrderPriceStatesRequest] = useRequest({
        requestId,
        query: bimWorkOrderPriceStatesGql,
        variables,
        withEffect: !!chapter && !!workOrderObjectId,
    });

    const bimWorkOrderPriceStatesMakeRequest = useCallback(() => {
        dispatch(bimWorkOrderPriceStatesRequest(variables));
    }, [bimWorkOrderPriceStatesRequest, dispatch, variables]);

    const data = useMemo(
        () => bimWorkOrderPriceStatesData?.bimWorkOrderPriceStates?.data || ({} as BimWorkOrderPriceStatesData),
        [bimWorkOrderPriceStatesData?.bimWorkOrderPriceStates?.data],
    );

    useEffect(() => {
        bimWorkOrderPriceStatesReset(undefined);
    }, [bimWorkOrderPriceStatesReset]);

    return {
        bimWorkOrderPriceStatesData: data,
        bimWorkOrderPriceStatesMakeRequest,
    };
};
